import React, {useReducer} from 'react';
import CartaContext from './cartaContext';
import CartaReducer from './cartaReducer';
import clienteAxios from '../../config/axios';
import tokenAuth  from '../../config/tokenAuth';
import {
    OBTENER_MENU_ADMIN,
    OBTENER_MENU_STOCK,
    OBTENER_MENU_STOCK_ERROR,
    OBTENER_MENU_ADMIN_ERROR
   
} from '../../types';


const CartaState = (props) =>{
    const initialState = {
        platos: null,
        ingredientes : null,
        bebidas : null,
        bebidaSalon : null,
        mensaje : null,
        cargando : true,
        
    };

    const [state , dispatch] = useReducer(CartaReducer, initialState);

    //FUNCIONES
    
    const obtenerMenuStock = async() => {
        const token = localStorage.getItem('token')
        if(token){
            tokenAuth(token)
        }
        try {
            const platos = await clienteAxios.get('/api/platos');
            const ingredientes = await clienteAxios.get('api/ingredientes');
            const bebidas = await clienteAxios.get('/api/bebidas/delivery');
            const bebidaSalon = await clienteAxios.get('/api/bebidas');
            
            
            dispatch({
                type : OBTENER_MENU_STOCK,
                payload : {
                    platos : platos.data.platos,
                    ingredientes : ingredientes.data.ingredientes,
                    bebidas : bebidas.data.bebidas,
                    bebidaSalon : bebidaSalon.data.bebidas
                }
            })
            
        } catch (error) {
            if(error.message){
                dispatch({
                    type : OBTENER_MENU_STOCK_ERROR,
                    payload: error.message
                })
            }else{
                dispatch({
                    type : OBTENER_MENU_STOCK_ERROR,
                    payload : error.response.data.msg
                })
            }
           
              
            
          
        }
     
    }
    const obtenerMenu = async() => {
        const token = localStorage.getItem('token')
        if(token){
            tokenAuth(token)
        }
        try {
            const platos = await clienteAxios.get('/api/platos/all');
            const ingredientes = await clienteAxios.get('api/ingredientes/all');
            const bebidas = await clienteAxios.get('/api/bebidas/all');
            
            dispatch({
                type : OBTENER_MENU_ADMIN,
                payload : {
                    platos : platos.data.platos,
                    ingredientes: ingredientes.data.ingredientes,
                    bebidas : bebidas.data.bebidas,
                    
                }
            })
        } catch (error) {
            if(error.message){
                dispatch({
                    type : OBTENER_MENU_ADMIN_ERROR,
                    payload: error.message
                })
            }else{
                dispatch({
                    type : OBTENER_MENU_ADMIN_ERROR,
                    payload : error.response.data.msg
                })
            }
        }
    }

    return (
        <CartaContext.Provider
                value={{
                    platos : state.platos,
                    ingredientes : state.ingredientes,
                    bebidas : state.bebidas,
                    bebidaSalon : state.bebidaSalon,
                    cargando : state.cargando,
                    obtenerMenuStock,
                    obtenerMenu
                }}

        >
            {props.children}
        </CartaContext.Provider>
    )
}

export default CartaState;